var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticStyle:{"overflow-y":"auto"}},[_c('v-list',{attrs:{"dense":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }